import { t } from "@/i18n";
import { Bird, Cake, Cat, Crown, Dog, Fish, Flower2, Gem, Heart, Medal, Paintbrush, Palette, Rainbow, Rocket, Smile, Sparkles, Star, Sun, Trophy, Zap } from "lucide-react";

export const STICKERS = [
  { id: "star", text: t("super_star"), icon: Star, bg: "#FFD166" },
  { id: "trophy", text: t("masterpiece"), icon: Trophy, bg: "#4ECDC4" },
  { id: "crown", text: t("colour_champ"), icon: Crown, bg: "#FF9FF3" },
  { id: "sparkles", text: t("rainbow_hero"), icon: Sparkles, bg: "#54A0FF" },
  { id: "rocket", text: t("out_of_this_world"), icon: Rocket, bg: "#1DD1A1" },
  { id: "heart", text: t("made_with_love"), icon: Heart, bg: "#FF5252" },
  { id: "sun", text: t("bright_idea"), icon: Sun, bg: "#FF9F43" },
  { id: "rainbow", text: t("rainbow_maker"), icon: Rainbow, bg: "#C8D6E5" },
  { id: "palette", text: t("palette_pro"), icon: Palette, bg: "#845EC2" },
  { id: "brush", text: t("brush_boss"), icon: Paintbrush, bg: "#48DBFB" },
  { id: "cat", text: t("cool_cat"), icon: Cat, bg: "#FECA57" },
  { id: "dog", text: t("top_dog"), icon: Dog, bg: "#C8A27A" },
  { id: "fish", text: t("splashy"), icon: Fish, bg: "#4D96FF" },
  { id: "bird", text: t("high_flyer"), icon: Bird, bg: "#10AC84" },
  { id: "flower", text: t("blooming"), icon: Flower2, bg: "#F368E0" },
  { id: "zap", text: t("super_speedy"), icon: Zap, bg: "#FFD166" },
  { id: "gem", text: t("shiny_gem"), icon: Gem, bg: "#00C9A7" },
  { id: "medal", text: t("gold_medal"), icon: Medal, bg: "#FF9F43" },
  { id: "smile", text: t("happy_artist"), icon: Smile, bg: "#4ECDC4" },
  { id: "cake", text: t("piece_of_cake"), icon: Cake, bg: "#FF9FF3" },
];

export const STICKER_MAP = Object.fromEntries(STICKERS.map((s) => [s.id, s]));

export const MILESTONES = [
  { id: "bronze-row", at: 10, text: t("bronze_row"), blurb: t("you_filled_a_whole_row_of_stickers"), icon: Medal, bg: "#CD7F32" },
  { id: "gold-shelf", at: 20, text: t("gold_shelf"), blurb: t("every_single_sticker_collected"), icon: Trophy, bg: "#FFD700" },
];
export const MILESTONE_MAP = Object.fromEntries(MILESTONES.map((m) => [m.id, m]));
